import React, { memo, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'components';
import ApplicantTimestamp from './ApplicantTimestamp';
import ManageApplication from './ManageApplication';
import './UpdateAppStatus.scss';

interface Props {
    showModal: boolean,
    onClose: ((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void) | undefined,
    detail?: { applicantHistories, applicantStatus, applicantPhoneNumbers, id },
    onGetApplicantTimeStamp,
    onUpdateApplicantStatus,
    onGetFilePdfAction,
    onGetImageAction,
    onGetPDFSimulationAction
}

const UpdateAppStatusPopup: React.FC<Props> = ({
  onClose = () => {}, showModal = false, detail = {}, onGetApplicantTimeStamp, onUpdateApplicantStatus, onGetFilePdfAction, onGetImageAction, onGetPDFSimulationAction,
}) => {
  const intl = useIntl();
  const [timeStapms, setTimeStamp] = useState(null);
  useEffect(() => {
    if (detail.id) {
      onGetApplicantTimeStamp(detail.id).then((res) => {
        setTimeStamp(res.applicantTimestamps);
      });
    }
  }, [detail.id, onGetApplicantTimeStamp]);
  
  return (
    <Modal
      showModal={showModal}
      onClose={onClose}
      customClassName="update-status"
      tabs={[{
        label: intl.formatMessage({ id: 'dashboard.updateApp.updateAppStatus' }),
      }, {
        label: intl.formatMessage({ id: 'dashboard.updateApp.applicantTimestamp' }),
      }]}
    >
      <ManageApplication
        intl={intl}
        detail={detail}
        onUpdateApplicantStatus={onUpdateApplicantStatus}
        onGetFilePdfAction={onGetFilePdfAction}
        onGetImageAction={onGetImageAction}
        onGetPDFSimulationAction={onGetPDFSimulationAction}
      />
      <ApplicantTimestamp intl={intl} applicantHistories={timeStapms} />
    </Modal>
  );
};

export default memo(UpdateAppStatusPopup);
